import styled from '@emotion/styled'
import {theme} from '../../features/Dashboard/theme'

export const HeaderContainer = styled.header`
  // background: ${theme.colors.surface};
  // border-bottom: 1px solid ${theme.colors.border};
  // padding: 12px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  gap: 16px;

  @media (max-width: 768px) {
    padding: 10px 16px;
    gap: 10px;
  }
`

export const HamburgerBtn = styled.button`
  display: none;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${theme.colors.text};
  flex-shrink: 0;
  padding: 0;
  margin-right: 6px;

  &:focus {
    outline: none;
  }

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
  }
`

export const LeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  @media (max-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`

export const Breadcrumb = styled.div`
  font-size: 12px;
  color: ${theme.colors.muted};
  font-family: ${theme.font.family};

  a {
    color: ${theme.colors.muted};
    text-decoration: none;

    &:hover {
      color: ${theme.colors.text};
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`

export const PageTitle = styled.h1`
  font-family: ${theme.font.family};
  font-size: 18px;
  font-weight: 400;
  color: ${theme.colors.text};
  margin: 0;
  line-height: 1.2;

  @media (max-width: 768px) {
    display: none;
  }
`

export const TitleBold = styled.span`
  font-weight: 700;
`

export const RightBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${theme.colors.bg};
  padding: 5px 10px;
  border-radius: ${theme.radius.full};

  @media (max-width: 480px) {
    gap: 4px;
    padding: 4px 6px;
  }
`

export const NewProposalBtn = styled.button`
  background: ${theme.colors.secondary};
  color: ${theme.colors.surface};
  border: none;
  border-radius: ${theme.radius.full};
  padding: 9px 18px;
  font-size: 14px;
  font-weight: 600;
  font-family: ${theme.font.family};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: filter ${theme.transition.fast};
  white-space: nowrap;

  &:hover {
    filter: brightness(1.1);
  }

  &:focus {
    outline: none;
  }

  @media (max-width: 480px) {
    padding: 7px 12px;
    font-size: 13px;
  }
`

export const BtnPlusIcon = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  line-height: 1;
  flex-shrink: 0;
  color: ${theme.colors.secondary};
`

export const HeaderIconBtn = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 1px solid ${theme.colors.border};
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${theme.colors.muted};
  transition: background ${theme.transition.fast};
  flex-shrink: 0;

  &:hover {
    background: ${theme.colors.hover};
    color: ${theme.colors.text};
  }

  &:focus {
    outline: none;
  }
`

export const UserChip = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 4px 4px 12px;
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.full};
  cursor: pointer;
  transition: background ${theme.transition.fast};
  position: relative;

  &:hover {
    background: ${theme.colors.hover};
  }
`

export const UserDropdown = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 220px;
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radius.lg};
  box-shadow: ${theme.shadow.popout};
  z-index: 200;
  overflow: hidden;
`

export const DropdownSection = styled.div`
  padding: 12px 16px;
  background: ${theme.colors.bg};
  border-bottom: 1px solid ${theme.colors.border};
`

export const DropdownRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-family: ${theme.font.family};
  line-height: 1.8;
`

export const DropdownKey = styled.span`
  color: ${theme.colors.muted};
  min-width: 82px;
`

export const DropdownVal = styled.span`
  color: ${theme.colors.text};
  font-weight: 500;
`

export const DropdownDivider = styled.div`
  height: 1px;
  background: ${theme.colors.border};
`

export const DropdownLogoutBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 10px 16px;
  border: none;
  background: transparent;
  font-size: 13px;
  font-family: ${theme.font.family};
  color: ${theme.colors.danger};
  cursor: pointer;
  text-align: left;
  transition: background ${theme.transition.fast};

  &:hover {
    background: #fef2f2;
  }

  &:focus {
    outline: none;
  }
`

export const UserName = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: ${theme.colors.text};
  font-family: ${theme.font.family};
  white-space: nowrap;

  @media (max-width: 480px) {
    display: none;
  }
`

export const UserAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid ${theme.colors.primary};
  background: ${theme.colors.secondary};
  color: ${theme.colors.subtle};
  font-size: 11px;
  font-weight: 700;
  font-family: sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`
